import Vue from 'vue'

/**
 * 权限指令
 */
const hasPermission = Vue.directive('hasPermission', {
  inserted: function (el, binding, vnode) {
    let value = binding.value.key;
    if (!Vue.prototype.$_hasPermission(value)) {
      el.parentNode.removeChild(el);
    }
  }
});

// 权限检查方法
Vue.prototype.$_hasPermission = function (value) {
  // 获取按钮权限
  let btnPermissions = JSON.parse(sessionStorage.getItem("permissions"));
  if(btnPermissions == undefined || btnPermissions == null) {
    return false;
  }
  if(btnPermissions.includes(value)){
    return true;
  }
  return false;
};
const noPermission = Vue.directive('noPermission', {
  inserted: function (el, binding, vnode) {
    let value = binding.value.key;
    if (!Vue.prototype.$_noPermission(value)) {
      el.parentNode.removeChild(el);
    }
  }
});

// 权限检查方法
Vue.prototype.$_noPermission = function (value) {
  // 获取按钮权限
  let btnPermissions = JSON.parse(sessionStorage.getItem("permissions"));
  if(btnPermissions == undefined || btnPermissions == null) {
    return true;
  }
  return !btnPermissions.includes(value);
};
/**
 * 角色指令
 */
const hasRole = Vue.directive('hasRole', {
  inserted: function (el, binding, vnode) {
    let value = binding.value.key;
    if (!Vue.prototype.$_hasRole(value)) {
      el.parentNode.removeChild(el);
    }
  }
});

// 权限检查方法
Vue.prototype.$_hasRole = function (value) {
  // 获取角色编码集合
  let roles = JSON.parse(sessionStorage.getItem("roles"));
  if(roles == undefined || roles == null) {
    return false;
  }
  if(roles.includes(value)){
    return true;
  }
  return false;
};

const noRole = Vue.directive('noRole', {
  inserted: function (el, binding, vnode) {
    let value = binding.value.key;
    if (!Vue.prototype.$_noRole(value)) {
      el.parentNode.removeChild(el);
    }
  }
});

// 权限检查方法
Vue.prototype.$_noRole = function (value) {
  // 获取按钮权限
  let roles = JSON.parse(sessionStorage.getItem("roles"));
  if(roles == undefined || roles == null) {
    return true;
  }
  return !roles.includes(value);
};

/**
 * 角色委派指令
 */
const hasDelegateRole = Vue.directive('hasDelegateRole', {
  inserted: function (el, binding, vnode) {
    let value = binding.value.key;
   // let delegateStepId = binding.value.delegateStepId;
    if (!Vue.prototype.$_hasDelegateRole(value)) {
      el.parentNode.removeChild(el);
    }
  }
});
// 权限检查方法
Vue.prototype.$_hasDelegateRole = function (value) {
  // 获取角色编码集合
  var roles = JSON.parse(sessionStorage.getItem("roles"));
  var delegateStepId=JSON.parse(sessionStorage.getItem("delegateStepId"));
  if(roles.includes('director'))  return true;
  if(roles.includes('deputyDirector') && delegateStepId==3)  return true;
  if(roles.includes('deptManager') && delegateStepId==4)  return true;
  return false;
};
export {hasDelegateRole}



// WEBPACK FOOTER //
// ./src/directive/index.js